import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import cascaderSelect from '@blade-sxp/search-center/pages/components/result/components/index.vue';
let default_1 = class default_1 extends Vue {
    multiple;
    attributesOptions;
    customedDisabledFunc;
    placeholder;
    value;
    disabled;
    collapseTags;
    onValueChange(value) {
        this.$emit('update:value', value);
    }
    onLabelChange(label) {
        this.$emit('update:label', label);
    }
    getCascaderStatus(value) {
        this.$emit('cascader-status', value);
    }
    remove(val) {
        this.$emit('remove-value', val);
    }
};
__decorate([
    Prop()
], default_1.prototype, "multiple", void 0);
__decorate([
    Prop()
], default_1.prototype, "attributesOptions", void 0);
__decorate([
    Prop()
], default_1.prototype, "customedDisabledFunc", void 0);
__decorate([
    Prop()
], default_1.prototype, "placeholder", void 0);
__decorate([
    Prop()
], default_1.prototype, "value", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "collapseTags", void 0);
default_1 = __decorate([
    Component({
        name: 'device-cascader-select',
        components: { cascaderSelect },
        i18n: {
            messages: { en: {} },
        },
    })
], default_1);
export default default_1;
